import { checkRedirectURL } from '@modules/authentication/utils';
import { RETURN_PATH_QUERY_PARAM } from '@modules/common/constants';
import { decodeOAuthState } from '@modules/integrationsV2/utils/decodeOAuthState';
import { INVITE_CODE_QUERY_PARAM } from '@modules/users/constants';
import AuthService from 'services/AuthService';

export const redirectOnLogin = (searchParams: URLSearchParams) => {
  // Workaround, for some reason, sometimes searchParams is empty
  // TODO: Investigate why this is happening and fix it
  const searchParamsToUse =
    searchParams.size === 0
      ? new URLSearchParams(window.location.search)
      : searchParams;

  const { state } = Object.fromEntries(searchParamsToUse);

  const {
    [`${RETURN_PATH_QUERY_PARAM}`]: returnTo,
    [`${INVITE_CODE_QUERY_PARAM}`]: inviteCode,
    ...rest
  } = Object.fromEntries(searchParamsToUse);

  if (inviteCode) {
    window.location.href = `/?${INVITE_CODE_QUERY_PARAM}=${inviteCode}&${RETURN_PATH_QUERY_PARAM}=${returnTo}`;
    return;
  }

  // Handle redirection to returnTo URL in case of SSO.
  // decodedState here will be undefined.
  if (!AuthService.isGoogleAuth()) {
    const decodedState = decodeOAuthState(state);
    if (
      decodedState &&
      'returnTo' in decodedState &&
      typeof decodedState.returnTo === 'string'
    ) {
      window.location.href = decodedState.returnTo;
      return;
    }
  }

  if (!returnTo || checkRedirectURL(returnTo) || returnTo.includes('logout')) {
    window.location.href = '/';
    return;
  }

  const queryParamString = new URLSearchParams(rest).toString();
  window.location.href = `${decodeURIComponent(`${returnTo}`)}${
    queryParamString ? `?${queryParamString}` : ''
  }`;
};
